<div id="labs">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class=" inner-card">
                    <h4 class="card-title ">ART & CRAFT</h4>
                    <div class="card-body text-justify">
                        <p class="inner-lead"><i>"Being CReAtive ISN'T A HOBBY of way IT'S Life"</i></p>
                        <p class="inner-lead"><i>“Creativity is seeing the same thing but thinking differently“
                        </i></p>
                        <div class="row">
                            <div class="col-6 text-center mb-4">
                                <a href="/assets/img/labs/arts/1.jpg" data-lightbox="Art & Craft"><img src="/assets/img/labs/arts/1.jpg" alt="Art & Craft" class="img-fluid rounded"></a>
                            </div>
                            <div class="col-6 text-center mb-4">
                                <a href="/assets/img/labs/arts/2.jpg" data-lightbox="Art & Craft"><img src="/assets/img/labs/arts/2.jpg" alt="Art & Craft" class="img-fluid rounded"></a>
                            </div>
                            <div class="col-6 text-center mb-4">
                                <a href="/assets/img/labs/arts/3.jpg" data-lightbox="Art & Craft"><img src="/assets/img/labs/arts/3.jpg" alt="Art & Craft" class="img-fluid rounded"></a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>